const SAVINGS_TOKEN = `{savingsAmount}`;
const generateFreightText = (templateString, savingsAmount) => {
  if (!templateString || !savingsAmount) {
    return "";
  }
  return templateString.replace(SAVINGS_TOKEN, savingsAmount);
};
export {
  generateFreightText
};
